<script>
  import { createEventDispatcher } from "svelte";

  export let filters = [];
  export let mode = "all";
  export let selectedFilters = [];

  const dispatch = createEventDispatcher();

  function getChangeClass(change) {
    return `change_filter_${change.trim().toLowerCase().replace(/\s+/g, "_")}`;
  }
</script>

<div class="change_filters">
  <button
    type="button"
    class="change_filter all"
    class:active={mode === "all"}
    aria-pressed={mode === "all"}
    on:click={() => dispatch("all")}
  >
    All
  </button>
  <button
    type="button"
    class="change_filter none"
    class:active={mode === "none"}
    aria-pressed={mode === "none"}
    on:click={() => dispatch("none")}
  >
    None
  </button>
  {#each filters as filter}
    <button
      type="button"
      class="change_filter {getChangeClass(filter)}"
      class:active={mode === "all" || selectedFilters.includes(filter)}
      aria-pressed={mode === "all" || selectedFilters.includes(filter)}
      on:click={() => dispatch("toggle", filter)}
    >
      {filter}
    </button>
  {/each}
</div>

<style>
  .change_filters {
    --change-pill-height: 1.5rem;
    align-items: center;
    background: var(--pax-white);
    border-bottom: var(--bw) solid var(--pax-black);
    display: flex;
    gap: 0.5rem;
    min-height: var(--change-pill-height);
    padding: 0.65rem;
  }

  .change_filter {
    align-items: center;
    appearance: none;
    border: 0;
    border-radius: 999px;
    box-sizing: border-box;
    color: var(--pax-black);
    cursor: pointer;
    display: inline-flex;
    font-size: 0.78rem;
    height: var(--change-pill-height);
    justify-content: center;
    line-height: 1;
    margin: 0;
    opacity: 0.32;
    padding: 0 0.55rem;
    transition: opacity 140ms ease-in-out;
    white-space: nowrap;
  }

  .change_filter:hover,
  .change_filter.active {
    opacity: 1;
  }

  .change_filter.all,
  .change_filter.none.active {
    background: var(--pax-black);
    color: var(--pax-white);
  }

  .change_filter_removed {
    background: #e6a7ad;
  }

  .change_filter_added {
    background: #b7e3bd;
  }

  .change_filter_changed {
    background: #e5e8a8;
  }

  .change_filter_layout_changed {
    background: #abcfe8;
  }
</style>
